var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe-integration',{attrs:{"app":_vm.app,"path":_vm.path,"params":_vm.params}})
}
var staticRenderFns = []

export { render, staticRenderFns }